import React from 'react';
import "./Header.css";

const Header = () => {
    return (
        <div className='header'>
            <h1 className='heading'>Welcome to Laptop-City</h1>
            <h4>Find your best-budget laptop here...</h4>
        </div>
    );
};

export default Header;